<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-15 15:08:00
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-12-10 11:11:45
 -->
<template>
  <div id="home-layout">
    <TheNavMenu class="layout-left the-nav-menu" />
    <div class="layout-right">
      <TheHead />
      <div class="rightContent">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import TheHead from '@/components/TheHead'
import TheNavMenu from '@/components/TheNavMenu'

export default {
  name: 'HomeLayout',
  components: {
    TheHead,
    TheNavMenu,
  },
}
</script>

<style lang="less" scoped>
#home-layout {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;

  .layout-left {
    width: 220px;
    background-color: #545c64;
    min-height: 100vh;
    border-right: 1px solid #dfdfdf;
  }

  .layout-right {
    min-width: 1072px;
    width: calc(~"100% - 220px");
    background-color: #ffff;
    height: 100vh;
    .rightContent {
      width: calc(100% - 20px);
      height: calc(100% - 76px);
      overflow-y: scroll;
      padding: 10px;
    }
  }
}
</style>
